import React from 'react';

import { getSectionId } from '../utils/getters';

import BlockContent from './BlockContent';
import Anchor from './Anchor';

export default function SlidingCard({ card }) {
  const { blockContent } = card;
  return (
    <>
      {card && (
        <>
          <Anchor section={card} />
          <div className="sliding-card" id={getSectionId(card)}>
            <BlockContent content={blockContent} />
          </div>
        </>
      )}
    </>
  );
}
